import { action, makeObservable, observable, computed, runInAction } from "mobx";
import { MrbBaseViewStore } from "mrb/core";
import { find } from "lodash";

class ProducerPreviewViewStore extends MrbBaseViewStore {
    @observable selectedTab = { value: 1, title: "Dashboard" };
    @observable selectedProducerId = null;
    @observable producers = [];

    tabs = [
        { value: 1, title: "Dashboard" },
        { value: 2, title: "Revenue" },
        { value: 3, title: "Catalog" },
        { value: 4, title: "Upload Content" },
    ];

    @computed get producerTypeSlug() {
        return this.rootStore.userStore?.producerType?.slug;
    }

    constructor(rootStore, { routeStore }) {
        super(rootStore);
        this.routeStore = routeStore;
        makeObservable(this);
    }

    async onInit() {
        var currentRoute = this.rootStore.routerStore.getCurrentRoute();
        if (currentRoute.name === "master.application.producer.preview.dashboard" && this.selectedTab.value !== 1) {
            this.setSelectedTab(1);
        } else if (
            currentRoute.name === "master.application.producer.preview.revenue" &&
            this.selectedTab.value !== 2
        ) {
            this.setSelectedTab(2);
        } else if (
            currentRoute.name === "master.application.producer.preview.catalog" &&
            this.selectedTab.value !== 3
        ) {
            this.setSelectedTab(3);
        } else if (
            currentRoute.name === "master.application.producer.preview.upload" &&
            this.selectedTab.value !== 4
        ) {
            this.setSelectedTab(4);
        }

        this.fetchProducers();
    }

    async fetchProducers() {
        try {
            const producers = await this.routeStore.getProducers();
            runInAction(() => {
                this.producers = producers || [];
            });
        } catch (_) {}
    }

    onViewUpdate(prevProps, newProps) {
        var currentRoute = this.rootStore.routerStore.getCurrentRoute();
        if (this.selectedTab.value === 2 && currentRoute.name === "master.application.producer.preview.dashboard") {
            this.setSelectedTab(1);
        }
    }

    @action.bound
    setSelectedTab(value) {
        this.selectedTab = find(this.tabs, { value: value });
    }

    @action.bound
    setSelectedProducerId(id) {
        this.selectedProducerId = id;
    }
}

export default ProducerPreviewViewStore;
